import React, { FC } from "react";
import { Field } from "react-final-form";
import "./RadioButton.scss";

interface RadioButtonProps {
  name: string;
  value: string;
  label: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
}

const RadioButton: FC<RadioButtonProps> = ({ name, value, label, disabled = false, onChange }) => {
  return (
    <Field name={name}>
      {({ input }) => (
        <div className={`radio-container-v2 ${disabled ? "radio-disabled" : ""}`}>
          <input
            type="radio"
            {...input}
            value={value}
            checked={input.value === value}
            onChange={() => {
              input.onChange(value);
              if (onChange) onChange(value);
            }}
            disabled={disabled}
          />
          <label>{label}</label>
        </div>
      )}
    </Field>
  );
};

export default RadioButton;
